import { type ComponentType, type SVGProps } from 'react';
import { cn } from '@zep-us/zus';
import { FileMdColorIcon, FilePdfColorIcon, FileTxtColorIcon, HancomOfficeHangulColorIcon, MicrosoftOfficeExcelColorIcon, MicrosoftOfficePowrpointColorIcon, MicrosoftOfficeWordColorIcon, PaperFillIcon, PictureFillIcon } from '@zep-us/zus-icons';
import { isAllowedAiImageExtension } from '@/shared/features/ai-quiz-generation/consts';

/** 문서 확장자(ALLOWED_AI_DOCUMENT_EXTENSIONS)별 컬러 아이콘 매핑 */
const EXTENSION_ICON: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  csv: MicrosoftOfficeExcelColorIcon,
  docx: MicrosoftOfficeWordColorIcon,
  hwp: HancomOfficeHangulColorIcon,
  hwpx: HancomOfficeHangulColorIcon,
  md: FileMdColorIcon,
  pdf: FilePdfColorIcon,
  pptx: MicrosoftOfficePowrpointColorIcon,
  txt: FileTxtColorIcon,
  xlsx: MicrosoftOfficeExcelColorIcon
};

/** 첨부 파일 확장자 아이콘 — 미지원 확장자는 PaperFill fallback. 크기는 className으로 지정 */
export const AiBuilderAttachmentExtensionIcon = ({
  extension,
  className
}: {
  extension?: string;
  className?: string;
}) => {
  const ExtensionIcon = extension ? EXTENSION_ICON[extension.toLowerCase()] : undefined;
  if (ExtensionIcon) {
    return <ExtensionIcon className={className} aria-hidden="true" />;
  }

  // 이미지 확장자는 전용 컬러 아이콘이 없어 단색 Picture 글리프로 대체한다.
  if (isAllowedAiImageExtension(extension)) {
    return <PictureFillIcon className={cn('text-strong', className)} fill="currentColor" aria-hidden="true" />;
  }
  return <PaperFillIcon className={cn('text-positive', className)} fill="currentColor" aria-hidden="true" data-sentry-element="PaperFillIcon" data-sentry-component="AiBuilderAttachmentExtensionIcon" data-sentry-source-file="AiBuilderAttachmentExtensionIcon.tsx" />;
};